<template>
	<div class="content">
		<section
			id="hero"
			class="container-expanded container band"
		>
			<h1>Live Masterclasses</h1>
			<h3>with Adam Voigt</h3>
		</section>
		<section
			id="intro"
			class="container-expanded container cols band"
		>
			<div class="col col-2" />
			<div class="col col-center">
				<h3 class="text-center">Adam Voigt will be running a series of live masterclasses exclusive to Real School partners.</h3>
				<p class="text-center">Registrations are required.</p>
			</div>
			<div class="col col-2" />
		</section>
		<section
			id="workshops"
			class="band"
		>
			<div class="cols">
				<div class="col col-1" />
				<div class="col">
					<div class="workshops">
						<!--
							Placeholder for the next masterclass, held back until one is announced: replace
							the content below — including the route it links to — then remove the v-if to
							surface it here. It still holds The Bullying Myth, which has run.
						-->
						<article
							v-if="false"
							class="text-center upcoming"
						>
							<h6>Adam's next masterclass</h6>
							<h2>The Bullying Myth</h2>
							<h5>
								Monday 26 October 2026<br />
								2.00pm – 3.30pm AEDT
							</h5>
							<p><strong>Stop adding more awareness to a problem everybody already knows exists.</strong></p>

							<router-link
								:to="{
									name: 'live-masterclasses',
								}"
								class="btn btn-primary"
							>
								More information and registrations
							</router-link>
						</article>

						<!-- Restorative Classroom Playbook — gated separately: hidden from Supported-tier schools -->
						<!-- Add v-if="false" once this workshop has run, then add its recording below -->
						<article
							v-if="canAccessRcp"
							class="text-center upcoming rcp"
						>
							<h6 class="series-label">Restorative Classroom Playbook</h6>
							<h2>Next workshop</h2>
							<h5>
								Friday 4 December 2026<br />
								10am – 3pm AEDT
							</h5>
							<p><strong>Move from compliance to cooperation – without carrying it all alone.</strong></p>

							<router-link
								:to="{
									name: 'restorative-classroom-playbook',
								}"
								class="btn btn-primary"
							>
								More information and registrations
							</router-link>
						</article>

						<h3>Previous masterclasses with Adam</h3>

						<article>
							<h2>The Bullying Myth</h2>
							<p><strong>Stop adding more awareness to a problem everybody already knows exists.</strong></p>
							<p>How to recognise bullying more accurately, respond confidently when it is happening, and build a school where there’s less of it to manage.</p>
							<YoutubeComponent id="s3b4VMtwEPQ" />
							<div class="text-center">
								<router-link
									:to="{
										name: 'the-bullying-myth-resources',
									}"
									class="btn btn-primary"
								>
									View resources
								</router-link>
							</div>
						</article>

						<article>
							<h2>The Teacher Retention Solution</h2>
							<p><strong>You can’t fix the teacher shortage. But you can make your school harder to leave.</strong></p>
							<p>What makes great teachers stay – and what you can do to keep more of them.</p>
							<YoutubeComponent id="_y6x37HFeuU" />
							<div class="text-center">
								<router-link
									:to="{
										name: 'the-teacher-retention-solution-resources',
									}"
									class="btn btn-primary"
								>
									View resources
								</router-link>
							</div>
						</article>

						<!-- Restorative Classroom Playbook — gated separately: hidden from Supported-tier schools -->
						<article
							v-if="canAccessRcp"
							class="rcp"
						>
							<h6 class="series-label">Restorative Classroom Playbook</h6>
							<h2>August 2026 Session</h2>
							<p><strong>Move from compliance to cooperation – without carrying it all alone.</strong></p>
							<YoutubeComponent id="AdRhbrRcXCo" />
							<div class="text-center">
								<a
									href="https://realschools.com.au/events/the-restorative-classroom-playbook/resources/"
									target="_blank"
									class="btn btn-primary"
									>View resources</a
								>
							</div>
						</article>

						<article>
							<h2>Suspend Smarter</h2>
							<p><strong>Suspend Smarter. Not Softer.</strong></p>
							<p>How to make better suspension decisions, use suspension time more productively, and reduce repeat suspensions – without lowering your standards.</p>
							<YoutubeComponent id="OMEJFMfZ4VA" />
							<div class="text-center">
								<router-link
									:to="{
										name: 'suspend-smarter-resources',
									}"
									class="btn btn-primary"
								>
									View resources
								</router-link>
							</div>
						</article>

						<!-- Restorative Classroom Playbook — gated separately: hidden from Supported-tier schools -->
						<article
							v-if="canAccessRcp"
							class="rcp"
						>
							<h6 class="series-label">Restorative Classroom Playbook</h6>
							<h2>July 2026 Session</h2>
							<p><strong>Move from compliance to cooperation – without carrying it all alone.</strong></p>
							<YoutubeComponent id="mqxAPH_Xyuo" />
							<div class="text-center">
								<a
									href="https://realschools.com.au/events/the-restorative-classroom-playbook/resources/"
									target="_blank"
									class="btn btn-primary"
									>View resources</a
								>
							</div>
						</article>

						<article id="the-ai-ready-student">
							<h2>The AI-Ready Student</h2>
							<p><strong>The Human Cost of AI Nobody Prepared Schools For</strong></p>
							<YoutubeComponent id="UqbdgdUxsFo" />
							<div class="text-center">
								<router-link
									:to="{
										name: 'the-ai-ready-student-resources',
									}"
									class="btn btn-primary"
								>
									View resources
								</router-link>
							</div>
						</article>

						<article>
							<h2>The Shame Responsive</h2>
							<p><strong>Behaviour Problems Are Often Shame Problems in Disguise</strong></p>
							<YoutubeComponent id="86vJ17LJfBU" />
							<div class="text-center">
								<router-link
									:to="{
										name: 'the-shame-responsive-school-resources',
									}"
									class="btn btn-primary"
								>
									View resources
								</router-link>
							</div>
						</article>

						<article>
							<h2>The Better Boys Blueprint</h2>
							<p><strong>Are you worried about our boys?</strong></p>
							<p>Design a clear, practical plan to help boys thrive – emotionally, relationally and academically.</p>
							<YoutubeComponent id="m9UwQ_mxeW0" />
							<div class="text-center">
								<router-link
									:to="{
										name: 'the-better-boys-blueprint-resources',
									}"
									class="btn btn-primary"
								>
									View resources
								</router-link>
							</div>
						</article>

						<article>
							<h2>The Collapse of Trust</h2>
							<p><strong>When trust collapses, everything else follows.</strong></p>
							<p>Behaviour. Engagement. Staff wellbeing. Parent confidence.</p>
							<p>Right now, trust in schools is fractured — and everyone can feel it.</p>
							<YoutubeComponent id="bty_SLWypW0" />
							<div class="text-center">
								<a
									href="https://realschools.com.au/events/the-collapse-of-trust/resources/"
									target="_blank"
									class="btn btn-primary"
									>View resources</a
								>
							</div>
						</article>

						<h3>2025</h3>
						<article>
							<h2>The Punishment Trap</h2>
							<p><strong>How to stop staff slipping into reactive discipline and lead the culture reset your school's been crying out for.</strong></p>
							<p>This online workshop will change how your staff respond to behaviour when things get tough.</p>
							<p>It's built for leaders ready to steer their school away from crackdowns and toward culture that actually works.</p>
							<YoutubeComponent id="_bLZt_GpHiI" />
							<div class="text-center">
								<a
									href="https://realschools.com.au/events/the-punishment-trap/resources/"
									target="_blank"
									class="btn btn-primary"
									>View resources</a
								>
							</div>
						</article>

						<article>
							<h2>The Bullying Breakthrough</h2>
							<p><strong>The real reason bullying persists in your school – and the cultural framework that starves it of oxygen.</strong></p>
							<p>Awareness isn't enough. This is how school leaders reduce the harm, fear and confusion around bullying at the root.</p>
							<p>The harm is real. The system is broken.</p>
							<YoutubeComponent id="S-DKXuiDIGI" />
							<div class="text-center">
								<a
									href="https://realschools.com.au/events/the-bullying-breakthrough/resources/"
									target="_blank"
									class="btn btn-primary"
									>View resources</a
								>
							</div>
						</article>

						<article>
							<h2>Winning Over Angry Parents</h2>
							<p><strong>How to handle furious emails, car park showdowns, and social media rants – calmly, clearly and confidently.</strong></p>
							<p>Get the secrets to building trust with the parents at your school, so future conflicts are less frequent, less intense, and easier to manage.</p>
							<YoutubeComponent id="t_sVI8ggef4" />
							<div class="text-center">
								<a
									href="https://realschools.com.au/events/winning-over-angry-parents/resources/"
									target="_blank"
									class="btn btn-primary"
									>View resources</a
								>
							</div>
						</article>

						<article>
							<h2>The Teacher Consistency Code</h2>
							<p><strong>How to Get Every Educator on the Same Page – Without a Revolt</strong></p>
							<p>A restorative, resistance-proof system for building real consistency in your school, without killing morale.</p>
							<YoutubeComponent id="N8kCc-dR0Tg" />
						</article>

						<article>
							<h2>The Student Engagement Overhaul</h2>
							<p><strong>The Proven Playbook to Transform Disengaged Learners into Switched-On Students</strong></p>
							<p>From passive, distracted kids to engaged, switched-on students – without bribery, threats, or a magic wand.</p>
							<YoutubeComponent id="BKIs4yjLMZo" />
							<div class="text-center">
								<a
									href="https://realschools.com.au/wp-content/uploads/2025/11/Student-Engagement-Catalogue.pdf"
									download="Student-Engagement-Catalogue.pdf"
									target="_blank"
									class="btn btn-primary"
									>View resources</a
								>
							</div>
						</article>
					</div>
				</div>
				<div class="col col-1" />
			</div>
		</section>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import heroImage from '@/images/hero-workshops.jpg';
import { wrapBackgroundImageUrlToCss } from '@/helpers';
import YoutubeComponent from '@/components/shared/YoutubeComponent.vue';
import { useUser } from '@/stores/userStore';
import { mapState } from 'pinia';

export default defineComponent({
	components: { YoutubeComponent },
	computed: {
		heroimageurl() {
			return wrapBackgroundImageUrlToCss(heroImage);
		},
		...mapState(useUser, ['canAccessRcp']),
	},
});
</script>

<style scoped lang="scss">
#hero {
	display: flex;
	position: relative;
	flex-direction: column;
	justify-content: flex-end;
	margin: 0;
	/* stylelint-disable-next-line declaration-property-value-no-unknown */
	background-image: v-bind(heroimageurl);
	background-position: center;
	background-size: cover;
	background-repeat: no-repeat;
	min-height: 300px;

	&::before {
		display: block;
		position: absolute;
		z-index: -1;
		inset: 0;
		background-color: rgba(0 0 0 / 30%);
		content: '';
	}

	h1 {
		margin: 0;
		color: white;
		text-shadow: 2px 2px 6px #00000082;
	}

	h3 {
		margin: 0;
		color: white;
		font-weight: bold;
		text-shadow: 2px 2px 6px #00000082;
		text-transform: uppercase;
	}
}

#intro {
	background-color: rgb(var(--rs-color-brand-navy));
	color: white;

	h3 {
		margin: 0;
		color: rgb(var(--rs-color-brand-mustard));
	}
}

#workshops {
	.workshops {
		article {
			margin-bottom: 40px;
			border-radius: 4px;
			background-color: rgb(var(--rs-color-brand-navy));
			padding: 40px;
			color: white;

			h2 {
				margin: 0 0 20px 0;
			}

			.youtube-container {
				margin: 60px auto 0 auto;
				max-width: 700px;
			}

			.btn {
				margin: 40px auto 0 auto;
			}

			&.upcoming {
				margin-bottom: 60px;

				h5 {
					color: white;
				}
			}

			&.rcp {
				.series-label {
					margin: 0 0 8px 0;
					color: rgb(var(--rs-color-brand-mustard));
					font-weight: bold;
					letter-spacing: 1px;
					text-transform: uppercase;
				}
			}
		}
	}
}
</style>
